import { render, staticRenderFns } from "./AddEditSubject.vue?vue&type=template&id=319b0b24"
import script from "./AddEditSubject.vue?vue&type=script&lang=js"
export * from "./AddEditSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports